"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useScrollOnMount = void 0;
const react_1 = require("react");
function useScrollOnMount(options) {
    (0, react_1.useEffect)(() => {
        window.scrollTo(Object.assign({ top: 0, left: 0, behavior: 'instant' }, options));
    }, []);
}
exports.useScrollOnMount = useScrollOnMount;
//# sourceMappingURL=scroll-on-mount.js.map